import React from "react";
import { useTranslation } from "react-i18next";

import footerBg from "../img/footer.png";
import iconPin from "../img/home/footer-pin.svg";
import iconPhone from "../img/home/footer-phone.svg";
import iconEmail from "../img/home/footer-email.svg";
import { LEGAL_DOCUMENTS } from "../legalDocuments";

const COMPANY_RECORDS = [
  {
    label: "Zefix company register",
    href: "https://www.zefix.ch/en/search/entity/list/firm/1242836",
  },
  {
    label: "GLEIF LEI record",
    href: "https://search.gleif.org/#/record/5067007N13A66V755382",
  },
];

function Footer() {
  const { t } = useTranslation();

  return (
    <footer className="relative overflow-hidden mt-0 sm:mt-[-320px]">
      {/* Background: 3D image fading into orange */}
      <div className="relative hidden sm:block w-full" style={{ height: "480px" }}>
         <img
          src={footerBg}
          alt=""
          aria-hidden
          className="absolute top-[162px] w-full h-full object-cover object-top pointer-events-none select-none"
        />
      </div>

      {/* Content area */}
      <div className="bg-[#ee5414]">
        <div className="glcontainer flex flex-col gap-[20px] sm:gap-[32px] pt-[36px] sm:pt-0 pb-[32px] sm:pb-[48px]">

          {/* Contact row */}
          <div className="flex flex-col sm:flex-row flex-wrap gap-[12px] sm:gap-[40px] mt-0 sm:mt-[200px]">
            <div className="flex items-center gap-[12px]">
              <img src={iconPin} alt="" className="w-[16px] h-[16px] shrink-0" />
              <span className="font-['Inter'] font-medium text-[14px] text-white leading-[1.4]">
                Via Pretorio 9, 6900 Lugano, Switzerland
              </span>
            </div>
            <div className="flex items-center gap-[12px]">
              <img src={iconPhone} alt="" className="w-[16px] h-[16px] shrink-0" />
              <a href="tel:+441224076240" className="font-['Inter'] font-medium text-[14px] text-white leading-[1.4] hover:opacity-75 transition-opacity">
                +44 1224 076240
              </a>
            </div>
            <div className="flex items-center gap-[12px]">
              <img src={iconEmail} alt="" className="w-[16px] h-[16px] shrink-0" />
              <a href="mailto:support@treefieldpartners.com" className="font-['Inter'] font-medium text-[14px] text-white leading-[1.4] hover:opacity-75 transition-opacity">
                support@treefieldpartners.com
              </a>
            </div>
          </div>

          {/* Disclaimer box */}
          <div className="bg-[rgba(255,255,255,0.03)] border border-[rgba(255,255,255,0.12)] rounded-[8px] px-[25px] py-[16px]">
            <p className="font-['Inter'] font-bold text-[12px] text-[#ffc7af] leading-normal mb-[10px]">
              {t("footer.disclaimer.title")}
            </p>
            <p className="font-['Inter'] font-normal text-[12px] text-[#ffa782] leading-[1.8]">
              {t("footer.disclaimer.text")}
            </p>
          </div>

          {/* Documents and company records */}
          <div className="flex flex-col gap-[16px]">
            <div>
              <p className="font-['Inter'] font-bold text-[12px] uppercase tracking-[0.08em] text-[#ffc7af]">{t("footer.documents")}</p>
              <div className="mt-[8px] flex flex-wrap gap-x-[24px] gap-y-[8px]">
                {LEGAL_DOCUMENTS.map((document) => (
                  <a
                    key={document.slug}
                    href={document.filePath}
                    target="_blank"
                    rel="noreferrer"
                    className="font-['Inter'] font-normal text-[13px] text-white leading-[1.65] hover:opacity-75 transition-opacity cursor-my"
                  >
                    {document.title}
                  </a>
                ))}
              </div>
            </div>
            <div>
              <p className="font-['Inter'] font-bold text-[12px] uppercase tracking-[0.08em] text-[#ffc7af]">{t("footer.companyDetails")}</p>
              <div className="mt-[8px] flex flex-wrap gap-x-[24px] gap-y-[8px] font-['Inter'] font-normal text-[13px] leading-[1.65] text-white">
                <span>CHE-181.316.128</span>
                <span>LEI 5067007N13A66V755382</span>
                {COMPANY_RECORDS.map((record) => (
                  <a
                    key={record.href}
                    href={record.href}
                    target="_blank"
                    rel="noreferrer"
                    className="hover:opacity-75 transition-opacity cursor-my"
                  >
                    {record.label}
                  </a>
                ))}
              </div>
            </div>
          </div>

          {/* Divider + copyright */}
          <div className="border-t border-[rgba(255,255,255,0.12)] pt-[16px]">
            <p className="font-['Inter'] font-normal text-[12px] text-[#ffa782] leading-[1.65]">
              © {new Date().getFullYear()} Treefield Partners AG. {t("footer.rights")}
            </p>
          </div>

        </div>
      </div>
    </footer>
  );
}

export default Footer;
